import React from "react";
import { usePutUsersIntegration } from "@/features/user/hooks/use-put-integration";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { useUsersIntegrationContext } from "@/features/user/contexts/users-integration-context";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

// 利用者統合モーダル
export const UserIntegrationConfirmModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    ownerId,
    password,
    registeredPassbooks,
    setOwnerId,
    setPassword,
  } = useUsersIntegrationContext();
  const {
    putUsersIntegration,
  } = usePutUsersIntegration();

  const handleClose = () => {
    setOwnerId("");
    setPassword("");
    onTapCloseModal();
  };

  return (
    <BasePageModal
      title="ユーザーの統合"
      className="md-user-integrat"
      handleClose={handleClose}
      bottomChildren={
        <BaseRoundButton
          buttonText="統合を開始"
          onClick={async() => {
            const result = await putUsersIntegration(ownerId, password);
            if (result) {
              onTapCompleteModal();
            }
          }}
        />
      }
      disableOverlayClose={true}
    >
      <h2>
        以下のデータをこちらへ統合します
      </h2>
      <ul>
        <li>
        <MailAddressForm
          className="required"
          id="userId"
          title="メールアドレス(利用者ID)"
          initialValue={ownerId}
          isReadOnly={true}
        />
        </li>
        <li>
          <label htmlFor="fcList">登録されている明細帳</label>
          <textarea
            id="fcList"
            value={registeredPassbooks.join("\n")}
            readOnly
          />
        </li>
      </ul>
      <div className="message">
        <p>統合すると元に戻すことはできません。</p>
      </div>
    </BasePageModal>
  );
};
